import type { FC } from 'react'
import styled from '@emotion/styled'

import { css } from '@emotion/react'

import HeroRecipeBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

const Description = () => {
  const pageConfig = usePageConfig()
  return (
    <>
      Twilio’s CDP is #1 for 2022 market share per {` `}
      <a href="https://segment.com/learn/download/idc-marketshare-2022/">IDC</a>, built for companies trying to grow in
      a privacy-conscious world. With built-in security, privacy, and resilience, it enables personalized experiences,
      regulatory compliance, and customer trust. Backed by industry-standard frameworks and {` `}
      <a href={getAbsoluteUrl(`/docs/guides/regional-segment/`, pageConfig)}>regional infrastructure</a>
      {` `} in Europe and the United States, Segment helps companies succeed with a privacy-first approach.
    </>
  )
}

const copy = {
  heading: `Segment Trust Center`,
  description: <Description />,
}

const Hero: FC = () => (
  <Wrapper>
    <StyledHeroRecipeBase variant="centered">
      <HeroRecipe.Copy>
        <CopyTextBase centered={true}>
          <CopyText.Heading tag="h1" variant="h1">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description tag="p" variant="pExtraLarge">
            {copy.description}
          </CopyText.Description>
        </CopyTextBase>
      </HeroRecipe.Copy>
    </StyledHeroRecipeBase>
  </Wrapper>
)

export default Hero

const StyledHeroRecipeBase = styled(HeroRecipeBase)`
  ${HeroRecipe.Wrapper} {
    gap: 0;

    ${({ theme }) => css`
      ${theme.breakpoints.up(`sm`)} {
        padding-bottom: 40px;
      }

      ${theme.breakpoints.up(`xl`)} {
        padding-bottom: 80px;
      }
    `}
  }
`

const Wrapper = styled.header`
  background-color: ${({ theme }) => theme.palette.twilio.gray[10]};
`
